import React from 'react'
import ArticleCard from '@/components/molecules/ArticleCard'

import './list-group.scss'

class ListGroupArticles extends React.Component {
  activeArticles = null

  renderArticles () {
    let ind = 0

    this.activeArticles = this.props.articles.filter(article => {
      for (let field of article.data.contents[0].fields) {
				if (field.id === 'categoryfilters') {
					if (field.fields[0].id === 'filter' && (this.props.activeCategory === 'all' || field.fields[0].value === this.props.activeCategory)) {
						return article
					}
        }
      }
    })

		return this.activeArticles.map(article => {
			if (article) {
				ind++
				return (
					<ArticleCard
						key={`home-events_${ind}`}
						article={article}
						{...this.props}
					/>
				)
			}
    })
  }

  render () {
    const articles = this.renderArticles()

    return (
      <div className='list-group'>
        <div className='list-group__container'>
          <h2 className='list-group__heading'>
            {this.props.optionalTitle || this.props.title}
          </h2>
					{articles.length ? articles : this.props.activeCategory === 'all' ? this.props.nocontent : <div className='list-group__nocontent'>There are no articles matching the selected filter.</div>}
        </div>
        <div class='list-group--waves' />
      </div>
    )
  }
}

export default ListGroupArticles



// WEBPACK FOOTER //
// ./src/components/organisms/groups/ListGroupArticles.js